export const LogoMark = ({ className = "h-9 w-9" }) => (
  <img src="/assets/mosaicon-logo.png" alt="" className={`${className} object-contain`} aria-hidden="true" />
);

const Logo = ({ light = false }) => (
  <span className="flex items-center gap-3" data-testid="brand-logo">
    <LogoMark />
    <span className="leading-none">
      <span className={`block font-sans font-bold tracking-[0.18em] text-sm ${light ? "text-cream" : "text-ink"}`}>
        MOSAICON
      </span>
      <span className={`block font-sans text-[10px] tracking-[0.42em] mt-1 ${light ? "text-gold" : "text-burgundy"}`}>
        STRATEGIES
      </span>
    </span>
  </span>
);

export default Logo;
